document.addEventListener('DOMContentLoaded', () => {
  const filterBtns = document.querySelectorAll<HTMLButtonElement>('.filter-btn')
  const cards = document.querySelectorAll<HTMLElement>('.noticia-card')
  const LIMIT = 4

  if (!filterBtns.length || !cards.length) return

  function applyFilter(filter: string) {
    let shown = 0

    for (const card of cards) {
      const cats = (card.dataset.categories ?? '').split(' ').filter(Boolean)
      const matches = filter === 'all' || cats.includes(filter)

      if (matches && shown < LIMIT) {
        card.classList.remove('hidden')
        shown++
      } else {
        card.classList.add('hidden')
      }
    }
  }

  // Estado inicial: mostrar os 4 mais recentes (all)
  applyFilter('all')

  for (const btn of filterBtns) {
    btn.addEventListener('click', () => {
      for (const b of filterBtns) b.classList.remove('active')
      btn.classList.add('active')
      applyFilter(btn.dataset.filter ?? 'all')
    })
  }
})
